<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `master/test-content/${inputs.id}`
            : `master/test-content`
        "
      >
      <div class="form-group row align-items-center">
          <label for="inputs_code" class="col-sm-3 mb-0">
            {{ $t("code") }}
          </label>
          <app-input
            id="inputs_code"
            class="col-sm-9"
            type="text"
            v-model="inputs.code"
            :placeholder="$t('code')"
            :required="true"
          />
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("name") }}
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-9"
            type="text"
            v-model="inputs.name"
            :placeholder="$t('name')"
            :required="true"
          />
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_is_active" class="col-sm-3 mb-0"> &nbsp; </label>
          <div class="col-sm-8">
            <app-input
              id="inputs_is_active"
              :list-value-field="$t('is_active')"
              type="single-checkbox"
              v-model="inputs.is_active"
            />
          </div>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";

export default {
  name: "ModalForm",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    formId: String,
    value: {
      type: Object,
      default: () => {
        return {
          id: undefined,
          code: "",
          name: "",
          is_active: "",
        };
      },
    },
  },
  data() {
    return {
      preloader: false,
      inputs: {
        code: "",
        name: "",
        is_active: "",
      },
      // statusLists: [
      //     {id: '', value: "Choose One",},
      //     {id: 'active', value: "Active",},
      //     {id: 'inactive', value: "Inactive",},
      //     {id: 'invited', value: "Invite",},
      // ],
      // genderLists: [
      //     {id: 'male', value: "Male"},
      //     {id: 'female', value: "Female"},
      //     {id: 'other', value: "Other"},
      // ],
      modalId: this.formId,
      modalTitle: this.$t("add"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      this.save(this.inputs);
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.preloader = false;
    },
  },
};
</script>
